module.exports = class CategoriesFormCtrl
  submit: ->
    @onSubmit(category: @category)
